/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { MarkerF } from "@react-google-maps/api";
import { FC, useState, useEffect } from "react";
import UserIcon from "assets/icon_user.png";
import { Const } from "const";
import { useGeolocation } from "react-use";

export const UserLocation: FC = () => {
  const [currentPos, setCurrentPos] = useState<google.maps.LatLngLiteral>();
  const pos = useGeolocation();
  useEffect(() => {
    if (!pos.loading && pos.latitude && pos.longitude) {
      console.debug({ lat: pos.latitude, lng: pos.longitude });
      setCurrentPos({ lat: pos.latitude, lng: pos.longitude });
    }
  }, [pos.latitude, pos.loading, pos.longitude]);

  return (
    <>
      {currentPos && (
        <MarkerF
          position={currentPos}
          icon={UserIcon}
          zIndex={Const.zIndex.userPosition}
        />
      )}
    </>
  );
};
